import e from "./ghl-ui.es1186.js";
import f from "./ghl-ui.es1187.js";
import i from "./ghl-ui.es1188.js";
function d(o, t, r) {
  return t === t ? i(o, t, r) : e(o, f, r);
}
export {
  d as default
};
